import { LazyLoadUtils } from "../../utils/index.js";

export const GreetingBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/greeting" */
      "./components/GreetingBox/GreetingBox.js"
    ),
  { componentName: "GreetingBox" }
);

export const BalanceBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/balance" */ "./components/BalanceBox/BalanceBox.js"
    ),
  { componentName: "BalanceBox" }
);

export const NotificationBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/notification" */ "./components/NotificationBox/NotificationBox.js"
    ),
  { componentName: "NotificationBox" }
);

export const LoyaltyIndicatorBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/loyalty" */ "../LoyaltyIndicator/LoyaltyIndicatorBox.js"
    ),
  { componentName: "LoyaltyIndicatorBox" }
);

export const ControlCenterBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/control-center" */ "./components/ControlCenter/ControlCenterBox.js"
    ),
  { componentName: "ControlCenterBox" }
);

export const HistoryBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/history" */ "./components/HistoryBox/HistoryBox.js"
    ),
  { componentName: "HistoryBox" }
);

export const UsefulLinkBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/useful-links" */ "./components/UsefulLinksBox/UsefulLinksBox.js"
    ),
  { componentName: "UsefulLinkBox" }
);

export const LinkItemChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/link-item" */ "./components/LinkItem/LinkItem.js"
    ),
  { componentName: "LinkItem" }
);

export const LinksBoxChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/links" */ "./components/LinksBox/LinksBox.js"
    ),
  { componentName: "LinksBox" }
);

export const BiometricLinkChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "box/biometrics-link" */ "./components/BiometricLink/BiometricLink.js"
    ),
  { componentName: "BiometricLink" }
);
